<template>
  <div>
    <div class="p-8 bg-gray-800">
      <div class="max-w-7xl mx-auto">
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 min-w-0">
            <h2 class="text-2xl font-bold leading-7 text-white sm:text-3xl sm:truncate">
              Acc Product Templates
            </h2>
          </div>
          <div class="mt-4 flex md:mt-0 md:ml-4 space-x-2">
            <CreateAction @created="refreshList" />
          </div>
        </div>
      </div>
    </div>
    <div class="p-8">
      <List ref="accProductTemplateList" />
    </div>
  </div>
</template>

<script>
import CreateAction from './components/create-action.vue';
import List from './components/list.vue';

export default {
  components: {
    CreateAction,
    List,
  },
  methods: {
    refreshList() {
      this.$refs.accProductTemplateList.resetList();
    },
  },
};
</script>
